import { Component } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navbar from "./components/navbar";
import Hero from "./components/hero";
import Surah from "./components/surah";
import Jws from "./components/jws";
import PerSurah from "./components/perSurah";
import Loading from "./components/Loading";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      isLoading: true,
    };
  }

  componentDidMount() {
    fetch(
      "https://raw.githubusercontent.com/penggguna/QuranJSON/master/quran.json"
    )
      .then((response) => response.json())
      .then((data) => this.setState({ items: data, isLoading: false }));
  }

  render() {
    const { items, isLoading } = this.state;
    if (isLoading) {
      return <Loading />;
    }

    return (
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Hero />} exact />
          <Route path="/surah" element={<Surah />} exact />
          <Route path="/jws" element={<Jws />} exact />
          {items.map((item, index) => (
            <Route
              path={`/surah/${item.number_of_surah}`}
              element={<PerSurah nomor={item.number_of_surah} />}
              exact
              key={index}
            />
          ))}
        </Routes>
      </BrowserRouter>
    );
  }
}
export default App;
